import React, { useState } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { ArrowLeft, User, Radio, BarChart3, LineChart, Calendar, FileText, Database, Activity } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router-dom';

export default function MockupGroupedTabs() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      <Sidebar />
      <div className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="flex items-center gap-4 mb-6">
          <Button
            variant="outline"
            size="icon"
            onClick={() => navigate('/ib-management/list')}
            className="border-[#2A2A2E] hover:border-[#3A3A3F] hover:bg-[#1C1C1F] text-[#F8F9FA]"
          >
            <ArrowLeft size={20} />
          </Button>
          <div>
            <h1 className="text-4xl font-bold font-heading text-[#F8F9FA]">FIRA IND</h1>
            <p className="text-[#ADB5BD]">IB Details & Performance</p>
          </div>
        </div>

        <div className="border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold text-[#06D6A0] mb-2">✨ SOLUTION 2: GROUPED HORIZONTAL TABS</h2>
          <p className="text-[#ADB5BD]">9 tabs grouped into logical categories dengan visual separation</p>
        </div>

        <Tabs defaultValue="profile" className="w-full">
          {/* Group 1: Identity */}
          <div className="mb-6">
            <p className="text-xs uppercase tracking-wider text-[#6C757D] mb-2 px-2">Identity & Overview</p>
            <TabsList className="bg-[#141416] border border-[#2A2A2E] w-auto">
              <TabsTrigger value="profile">
                <User size={14} className="mr-1.5" />
                Profile
              </TabsTrigger>
              <TabsTrigger value="overview">
                <Radio size={14} className="mr-1.5" />
                Overview
              </TabsTrigger>
            </TabsList>
          </div>

          {/* Group 2: Performance */}
          <div className="mb-6">
            <p className="text-xs uppercase tracking-wider text-[#6C757D] mb-2 px-2">Performance & Analytics</p>
            <TabsList className="bg-[#141416] border border-[#2A2A2E] w-auto">
              <TabsTrigger value="performance">
                <BarChart3 size={14} className="mr-1.5" />
                Performance
              </TabsTrigger>
              <TabsTrigger value="analytic">
                <LineChart size={14} className="mr-1.5" />
                Analytic
              </TabsTrigger>
              <TabsTrigger value="activity">
                <Calendar size={14} className="mr-1.5" />
                Activity
              </TabsTrigger>
            </TabsList>
          </div>

          {/* Group 3: Management */}
          <div className="mb-6">
            <p className="text-xs uppercase tracking-wider text-[#6C757D] mb-2 px-2">Data Management</p>
            <TabsList className="bg-[#141416] border border-[#2A2A2E] w-auto">
              <TabsTrigger value="campaign">
                <FileText size={14} className="mr-1.5" />
                Campaign
              </TabsTrigger>
              <TabsTrigger value="daily">
                <Database size={14} className="mr-1.5" />
                Daily Data
              </TabsTrigger>
              <TabsTrigger value="database">
                <Database size={14} className="mr-1.5" />
                Database
              </TabsTrigger>
              <TabsTrigger value="log">
                <Activity size={14} className="mr-1.5" />
                Log
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="profile">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Profile Content</h3>
              <p className="text-[#ADB5BD]">IB Biography, Monthly Targets, Team Members...</p>
            </div>
          </TabsContent>

          <TabsContent value="performance">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Performance Content</h3>
              <p className="text-[#ADB5BD]">Performance metrics dengan sub-tabs horizontal...</p>
            </div>
          </TabsContent>
        </Tabs>

        <div className="mt-6 grid grid-cols-2 gap-4">
          <div className="border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-4">
            <h3 className="text-sm font-semibold text-[#06D6A0] mb-2">✅ KELEBIHAN:</h3>
            <ul className="text-xs text-[#ADB5BD] space-y-1">
              <li>• Organized by function/category</li>
              <li>• Less overwhelming - small chunks</li>
              <li>• Visual hierarchy clear</li>
              <li>• Still familiar horizontal pattern</li>
            </ul>
          </div>
          <div className="border border-[#E63946] bg-[#E63946]/5 rounded-lg p-4">
            <h3 className="text-sm font-semibold text-[#E63946] mb-2">❌ KEKURANGAN:</h3>
            <ul className="text-xs text-[#ADB5BD] space-y-1">
              <li>• Takes vertical space (3 tab rows)</li>
              <li>• Need to remember which group</li>
              <li>• More clicks to explore</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}